export enum PagesStoreMode {
  NoSplitting = 0,
  BatchSplitting = 1,
  ManualPageSelection = 2,
}